export const ONE_SECOND_IN_MS = 1_000;
export const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS; // 60,000 milliseconds
export const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS; // 3,600,000 milliseconds
export const ONE_DAY_IN_MS = 24 * ONE_HOUR_IN_MS; // 86,400,000 milliseconds
